var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0001 25.8333C5.91243 25.8333 0.166748 20.0876 0.166748 13C0.166748 5.9123 5.91243 0.166626 13.0001 0.166626C20.0877 0.166626 25.8334 5.9123 25.8334 13C25.8334 20.0876 20.0877 25.8333 13.0001 25.8333ZM21.6328 18.9787C22.8101 17.282 23.5001 15.2216 23.5001 13C23.5001 7.20097 18.7991 2.49996 13.0001 2.49996C7.20109 2.49996 2.50008 7.20097 2.50008 13C2.50008 15.2216 3.19003 17.282 4.36734 18.9787C5.68036 17.2444 8.76579 16.5 13.0001 16.5C17.2344 16.5 20.3198 17.2444 21.6328 18.9787ZM19.9589 20.863C19.6174 19.6352 17.1644 18.8333 13.0001 18.8333C8.83581 18.8333 6.38275 19.6352 6.04129 20.863C7.89393 22.5038 10.3307 23.5 13.0001 23.5C15.6695 23.5 18.1062 22.5038 19.9589 20.863ZM13.0001 5.99996C10.1757 5.99996 8.33342 8.04835 8.33342 10.6666C8.33342 14.6652 10.3878 16.5 13.0001 16.5C15.5878 16.5 17.6667 14.7262 17.6667 10.9C17.6667 8.2418 15.8166 5.99996 13.0001 5.99996ZM10.6667 10.6666C10.6667 13.3141 11.6213 14.1666 13.0001 14.1666C14.3741 14.1666 15.3334 13.3481 15.3334 10.9C15.3334 9.44211 14.4183 8.33329 13.0001 8.33329C11.5228 8.33329 10.6667 9.28509 10.6667 10.6666Z",
    fill: "#6D927C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActive);
export default __webpack_public_path__ + "static/media/profile_active.0a37e910bb7698b6d7ad8db1e713739d.svg";
export { ForwardRef as ReactComponent };